import {  registerBrick } from 'olympe';
import {ReactBrick, useProperty} from "@olympeio/core";
import {combineLatest} from "rxjs";
import React from 'react';
import {format} from 'date-fns';
import { Bell, Check, Circle } from 'lucide-react';


export default class NotificationList extends ReactBrick {

    /**
     * @override
     */
    setupExecution($) {
        return combineLatest([
            $.observe('Hidden', false),
        ]);
    }
    /**
     * @override
     */
    static getReactComponent($) {
        return (props) => {
            const notificationsCO = useProperty($, 'notifications', true);
            const notifications = notificationsCO?.map(n => n.toJSON());
            const unreadCount = notifications?.filter(n => !n.read).length;

            const [hidden] = props.values;
            return !hidden && (
                <div className="w-full max-w-md bg-white rounded-lg shadow-lg">
                    {/* Header */}
                    <div className="p-4 border-b border-gray-200">
                        <div className="flex items-center justify-between">
                            <h2 className="text-xl font-bold text-gray-900">Notifications</h2>
                            <div className="flex items-center space-x-2">
                                <Bell className="h-5 w-5 text-gray-500" />
                                {unreadCount > 0 && (
                                    <div className="h-6 w-6 flex items-center justify-center bg-red-500 text-white text-xs font-bold rounded-full">
                                        {unreadCount}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Notifications Container */}
                    <div className="h-[400px] overflow-y-auto">
                        {notifications === undefined || notifications.length === 0 ? (
                            <div className="flex flex-col items-center justify-center h-full text-gray-500 p-4">
                                <Bell className="h-8 w-8 mb-2" />
                                <p>No notifications yet</p>
                            </div>
                        ) : (
                            <div className="p-4 space-y-4">
                                {notifications?.map((notification, index) => (
                                    <div
                                        key={index}
                                        className={`flex items-start space-x-4 p-3 rounded-lg transition-colors ${
                                            notification.read ? 'bg-gray-50' : 'bg-blue-50'
                                        }`}
                                    >
                                        {notification.read ? (
                                            <Check className="h-5 w-5 text-gray-400 mt-1 flex-shrink-0" />
                                        ) : (
                                            <Circle className="h-5 w-5 text-blue-500 fill-current mt-1 flex-shrink-0" />
                                        )}
                                        <div className="flex-1 min-w-0">
                                            <p className="text-sm text-gray-900 break-words">{notification.message}</p>
                                            <p className="text-xs text-gray-500 mt-1">{format(notification.date, 'dd.MM.yyyy')}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            );
        }
    }
}

registerBrick('01935e36f18e5eaa2805', NotificationList);
